module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-SemiBoldItalic.9789411a.ttf";